// DEV-AI-015: the backend address comes from REACT_APP_API_URL and nothing else. There is deliberately no fallback:
// a build with the address missing must fail loudly, never quietly talk to the live backend.
// Plain CommonJS on purpose: the build check (scripts/check-env.js) and the backend Jest suite use it too.

const MISSING = 'REACT_APP_API_URL is not set. casavello refuses to guess a backend address, because a wrong guess could read or change live data. Set REACT_APP_API_URL to the backend address (it must start with https://, or http://localhost for local work) and build again.';
const INVALID = 'REACT_APP_API_URL is not a valid web address. It must start with https:// (or http://localhost for local work), for example https://your-backend.example.com.';

// Returns { ok, url, error }. A trailing slash is removed so '/api/...' paths join cleanly.
function validateApiUrl(value) {
  const v = typeof value === 'string' ? value.trim() : '';
  if (!v) return { ok: false, url: '', error: MISSING };
  let u;
  try { u = new URL(v); } catch (e) { return { ok: false, url: '', error: INVALID }; }
  const local = u.protocol === 'http:' && (u.hostname === 'localhost' || u.hostname === '127.0.0.1');
  if (u.protocol !== 'https:' && !local) return { ok: false, url: '', error: INVALID };
  return { ok: true, url: v.replace(/\/+$/, ''), error: null };
}

module.exports = { validateApiUrl, MISSING, INVALID };
